// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__LXQB7","back-button-span":"BackButton_back-button-span__4r30L","back-button-icon":"BackButton_back-button-icon__sITac"};